import { useState, useEffect } from 'react';
import { requestGet } from '../utils/request';
import { getRootUrl } from '../utils/url';
import { getUserData } from '../utils/wam';
import { queryParam } from '../utils/queryString';
import { Operation } from '../hooks/useOperations/types';

const SERVICE_ENDPOINT = '/api/eva/api/v5/operations/owned';

export const useImpersonatedOperation = () => {
  const [operation, setOperation] = useState<Operation | undefined>();
  const [impersonatedUserId, setImpersonatedUserId] = useState('');
  const [isLoading, setIsLoading] = useState(true);

  const fetchImpersonatedOperation = async () => {
    const { clientId: loggedUserId } = getUserData();
    const impersonatedUserIdFromQuery = queryParam('client-id') as string;

    if (!loggedUserId || !impersonatedUserIdFromQuery || loggedUserId.toString() === impersonatedUserIdFromQuery.toString()) {
      setIsLoading(false);
      return;
    }

    try {
      const resp = await requestGet(
        `${getRootUrl()}${SERVICE_ENDPOINT}?userId=${impersonatedUserIdFromQuery}&farmInfo=false`
      );
      const op = await resp.json();
      setOperation(op);
      setImpersonatedUserId(impersonatedUserIdFromQuery);
    } catch (_) {
      // No impersonation data available. Do nothing.
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchImpersonatedOperation();
  }, []);

  return { isLoading, operation, impersonatedUserId };
};
